'use strict';

import React, { Component } from 'react';
import ValidationOverlay from './validationOverlay.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Grid, Box } from '@material-ui/core';
import InputText, { InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';


class Agent extends Component{

    state = {
        //Initiate Default User
        msg: "",
        popupState: this.props.popupState,
        popupStateValidation: false,
        agentID: "",
        Type: "Male",
        Name: "",
        Entreprise: "",
        Phone: "",
        Email: "",
        errmsg: "",
        urlAgent: "",
        userQ: [{id: "default_user_question",name:"default_user_question"}],
        userR: "default_user_question",
        otherQ: [{id: "default_other_question",name:"default_other_question"}],
        otherR: "default_other_question",
        familyQ: [{id: "default_family_question",name:"default_family_question"}],
        familyR: "default_family_question",
        prospectQ: [{id: "default_prospect_question",name:"default_prospect_question"}],
        prospectR: "default_prospect_question",
        commercialQ: [{id: "default_commercial_question",name:"default_commercial_question"}],
        commercialR: "default_commercial_question",
    }
    getInitialState(){
        return {
             //Initiate Default User
            msg: "",
            popupState: this.props.popupState,
            popupStateValidation: false,
            agentID: "",
            Type: "Male",
            Name: "",
            Phone: "",
            Email: "",
            Entreprise: "",
            errmsg: "",
            urlAgent: "",
            userQ: [{id: "default_user_question",name:"default_user_question"}],
            userR: "default_user_question",
            otherQ: [{id: "default_other_question",name:"default_other_question"}],
            otherR: "default_other_question",
            familyQ: [{id: "default_family_question",name:"default_family_question"}],
            familyR: "default_family_question",
            prospectQ: [{id: "default_prospect_question",name:"default_prospect_question"}],
            prospectR: "default_prospect_question",
            commercialQ: [{id: "default_commercial_question",name:"default_commercial_question"}],
            commercialR: "default_commercial_question",
        };
    }
    getInitialStateWithoutOption(){
        return {
            msg: "",
            popupState: this.props.popupState,
            popupStateValidation: false,
            agentID: "",
            Type: "Male",
            Name: "",
            Phone: "",
            Entreprise: "",
            Email: "",
            errmsg: "",
            urlAgent: "",
            userR: "default_user_question",
            otherR: "default_other_question",
            familyR: "default_family_question",
            prospectR: "default_prospect_question",
            commercialR: "default_commercial_question",
        };
    }
    onValidation= async (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.Email === '' && this.state.Phone === '') {
            this.setState({errmsg: "Email And Phone Of agent can not be empty"});
            return;
        }
        var msg = "Record Agent nom:" + this.state.Name + ", type: " + this.state.Type + ", tel :" + this.state.Phone + ", email : " + this.state.Email + ", ID Agent:" + this.state.agentID ;
        var url = "/agent/new/v2?id="+this.state.agentID+
        "&name=" + this.state.Name + "&type=" + this.state.Type + "&phone=" + this.state.Phone + "&email=" + this.state.Email +
         "&userR=" +this.state.userR+ "&otherR=" +this.state.otherR
         + "&familyR=" +this.state.familyR
         + "&prospectR=" +this.state.prospectR
         + "&entreprise=" +this.state.Entreprise
         + "&commercialR=" +this.state.commercialR;
        //Active Pop up Security
        this.setState({popupStateValidation: true, msg: msg, urlAgent: url});
        //Mise a jour de la liste
        this.props.onUpdate();
    }
    onClose= async (e) => {
        e.preventDefault();
        this.setState(this.getInitialStateWithoutOption());
        this.props.onCloseOverlay();
    }
    onValidationSucceed= async () => {
        this.setState(this.getInitialState());
        this.props.onCloseOverlay();
    }
    onCancelation= async () => {
        this.setState({popupStateValidation: false})
    }
    componentDidMount = async () => {
        console.log('[DEBUG], paygoGet All, load schema ');
        let listSchema = [];
        try {
            const response = await fetch('/schema/list', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content.lenght === 0) {
              console.log("[ERROR], getting schema getAll response ", resp)
              return;
            }
            //Parse content
            resp.content.map( item => {
                console.log(item);
                listSchema = listSchema.concat({id: item.id,name: item.name});
            });
            this.setState({
                userQ: this.state.userQ.concat(listSchema),
                otherQ: this.state.otherQ.concat(listSchema),
                familyQ: this.state.familyQ.concat(listSchema),
                prospectQ: this.state.prospectQ.concat(listSchema),
                commercialQ: this.state.commercialQ.concat(listSchema)
            });
          } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
          }
    }
    componentWillUnmount() {}
    render() {
        console.log('[DEBUG], User Questions',this.state.userQ);        
        console.log('[STATE]', this.state);        
        return (
            <PopUp
                title="Enregistrer un nouvel agent"
                close={this.props.onCloseOverlay}
                submitAction={this.onValidation}
            >
                <Box>
                    <b style={{'color': 'red'}}>{this.state.errmsg} </b>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="ID Agent"
                            value={this.state.agentID}
                            onChange={e => this.setState({agentID : e.target.value})}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            label="Type"
                            labelWidth="80"
                            value={this.state.Type}
                            onChange={e => this.setState({Type : e.target.value})}
                            options={[
                                <option key="Male" value="Male">Male</option>,
                                <option key="Female" value="Female">Female</option>
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Nom Agent"
                            value={this.state.Name}
                            onChange={e => this.setState({Name : e.target.value})}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Téléphone"
                            value={this.state.Phone}
                            onChange={e => this.setState({Phone : e.target.value})}
                        /> 
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Email"
                            value={this.state.Email}
                            onChange={e => this.setState({Email : e.target.value})}
                        /> 
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Entreprise"
                            value={this.state.Entreprise}
                            onChange={e => this.setState({Entreprise : e.target.value})}
                        /> 
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            labelWidth="250"
                            label="Questionnaire Inscription Commercial"
                            value={this.state.commercialR}
                            onChange={e => this.setState({commercialR: e.target.value})}
                            options ={ this.state.commercialQ.map( item => (
                                    <option key={item.id}  value={item.id}>{item.name} </option>
                                ))
                            }
                        
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            labelWidth="170"
                            label="Questionnaire Utilisateur"
                            value={this.state.userR}
                            onChange={e => this.setState({userR: e.target.value})}
                            options ={ this.state.userQ.map( item => (
                                    <option key={item.id}  value={item.id}>{item.name} </option>
                                ))
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            labelWidth="160"
                            label="Questionnaire Famille"
                            value={this.state.familyR}
                            onChange={e => this.setState({familyR: e.target.value})}
                            options ={ this.state.familyQ.map( item => (
                                    <option key={item.id}  value={item.id}>{item.name} </option>
                                ))
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            labelWidth="150"
                            label="Questionnaire Autre"
                            value={this.state.otherR}
                            onChange={e => this.setState({otherR: e.target.value})}
                            options ={ this.state.otherQ.map( item => (
                                    <option key={item.id}  value={item.id}>{item.name} </option>
                                ))
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            labelWidth="160"
                            label="Questionnaire Prospect"
                            value={this.state.prospectR}
                            onChange={e => this.setState({prospectR: e.target.value})}
                            options ={ this.state.prospectQ.map( item => (
                                    <option key={item.id}  value={item.id}>{item.name} </option>
                                ))
                            }
                        />
                    </Grid>
                </Grid>
                {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        // popupStateButton={this.state.popupStateValidation}
                        url={this.state.urlAgent}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                }
            </PopUp>
        );
    }
};
export default Agent
